import { useEffect, useState } from 'react'

// Custom hook to format text with line breaks on smaller screens
export const useResponsiveTabText = (text: string, breakpoint: number = 464): string => {
  const [formattedText, setFormattedText] = useState<string>(text)

  useEffect(() => {
    const formatText = () => {
      const shouldBreak = window.innerWidth <= breakpoint && text.includes(' ')
      setFormattedText(shouldBreak ? text.replace(/\s+/g, '\n') : text)
    }

    formatText()

    window.addEventListener('resize', formatText)

    return () => {
      window.removeEventListener('resize', formatText)
    }
  }, [text, breakpoint])

  return formattedText
}
